import { useAuth0 } from '@auth0/auth0-react';
import { useQuery } from '@tanstack/react-query';
import getApiBaseUrl from '@/utils/getBaseUrl';

export interface Profile {
  emailAddress: string;
  firstName: string;
  lastName?: string;
  auth0Id: string;
  createdAt: string;
  phoneNumber?: string;
  role?: 'AGENT' | 'USER';
  companyName?: string;
  licenseNumber?: string;
  photoUrl?: string;
  website?: string;
  identifier?: string;
  agent?: Profile;
}

export default function useGetProfile() {
  const { isAuthenticated, logout } = useAuth0();
  const token = window.localStorage.getItem('_token');
  const identifier = window.localStorage.getItem('agent');

  return useQuery<Profile>({
    queryKey: ['PROFILE'],
    queryFn: async () => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/users/profile${
          identifier ? `?agent=${identifier}` : ''
        }`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (!response.ok) {
        logout();
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      const { user, agent } = (await response.json()).data;

      return { ...user, agent };
    },
    enabled: isAuthenticated && !!token,
  });
}
